import type { PropsWithChildren, ReactNode } from 'react'

export function Panel({
  children,
  title,
  eyebrow,
  className = '',
}: PropsWithChildren<{
  title?: ReactNode
  eyebrow?: ReactNode
  className?: string
}>) {
  return (
    <section className={`panel ${className}`.trim()}>
      {eyebrow ? <div className="panel__eyebrow">{eyebrow}</div> : null}
      {title ? (
        <header className="panel__header">
          <h2>{title}</h2>
        </header>
      ) : null}
      {children}
    </section>
  )
}
